import { render, staticRenderFns } from "./supplements.vue?vue&type=template&id=fa886a22&"
import script from "./supplements.vue?vue&type=script&lang=js&"
export * from "./supplements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports